import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './Navbar';
import Home from './components/Home';
import Search from './components/Search';
import Teams from './components/Teams';
import Login from './components/Login';
import SignUp from './components/SignUp';
import Profile from './components/Profile';
import CommunityForums from './components/CommunityForums'; // Adjust path as necessary
import './App.css';

function App() {
    return (
        <Router>
            <div>
                <Navbar />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/search" element={<Search />} />
                    <Route path="/teams" element={<Teams />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/signup" element={<SignUp />} />
                    <Route path="/profile/:userId" element={<Profile />} />
                    <Route path="/forums" element={<CommunityForums />} />
                </Routes>
            </div>
        </Router>
    );
}

export default App;
